import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

// Schema is the same as ProvisionDevice (network corridor and site)
export const RetryProvisionFormSchema = z.object({
  networkCorridor: z.string().min(1, "Network Corridor is required"),
  networkSite: z.string().min(1, "Network Site is required"),
})

export type RetryProvisionFormData = z.infer<typeof RetryProvisionFormSchema>

/**
 * Transforms form data to API request for reprovisioning.
 *
 * Reprovision is a NEW provisioning request (not an update): we intentionally
 * omit deviceProvisioningInfoNumber so the backend creates a fresh provisioning
 * record with status 'requested'. The caller then links the new record's number
 * to the device (see composer).
 *
 * @param formData - The form data (network corridor and site)
 * @param deviceNumber - The device number
 * @returns API request payload
 */
export function transformToApiRequest(
  formData: RetryProvisionFormData,
  deviceNumber: number
) {
  return {
    provisioningInfo: {
      deviceNumber,
      // No deviceProvisioningInfoNumber → backend creates a NEW record.
      provisionedDeviceNumber: deviceNumber, // keep required id valid (avoid 0 default)
      networkCorridorNumber: parseInt(formData.networkCorridor),
      networkSiteNumber: parseInt(formData.networkSite),
      deviceProvisioningStatus: "requested",
      deviceProvisionRequestedDate: Math.floor(Date.now() / 1000),
      deviceProvisioningType: "test", // Reprovision is only available during testing phase
    },
  }
}
